// removed by extract-text-webpack-plugin
module.exports = {"bg":"xxS0fpe0XTOMHyuoeGtjI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Thumb/Thumb.scss
// module id = 1338
// module chunks = 1